import { TPromptSchema } from '@/model/tPromptDto'
import { Scope } from '@/model/scopeDTO.js'
import { z } from 'zod'

export const RewardSchema = z.object({
  uuid: z.string().nullable().default(''),
  issuer: z.string().nullable().default(''),
  tprompt: TPromptSchema.default({}),
  scope: Scope.default({}),
  inputText: z.string().default(''),
  temperature: z.number().nullable().default(0),
  outputText: z.array(z.string()).default([]),
  tokenUsage: z.array(z.number()).nullable().default([]),
  rerolls: z.number().nullable().default(0),
  timestamp: z.string().nullable().default(''),
  title: z.array(z.string()).default([]),
  propertiesKeys: z.record(z.array(z.any()))
})

export type Reward = z.infer<typeof RewardSchema>
